import { render, staticRenderFns } from "./OcrFrom.vue?vue&type=template&id=00858bd9&scoped=true&"
import script from "./OcrFrom.vue?vue&type=script&lang=js&"
export * from "./OcrFrom.vue?vue&type=script&lang=js&"
import style0 from "./OcrFrom.vue?vue&type=style&index=0&id=00858bd9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00858bd9",
  null
  
)

export default component.exports